export default __webpack_public_path__ + "static/bje-playbook-01-um-65326d0a14d126815cc9df33fd3704b6.jpg";